// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__3ci7H","container_video":"styles_container_video__MCZp2","video":"styles_video__dias1","content":"styles_content__fRMi8","button":"styles_button__1njCF"};